import ls from 'local-storage';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { PACKAGES_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';
import { getCombinedRequestFiltersAsJS } from '../selectors/validationSelectors';

const savePackagesCacheThunk = () => (dispatch, getState) => {
  const state = getState();
  ls.set(PACKAGES_LOCAL_STORAGE_CACHE_KEY, {
    ...getCombinedRequestFiltersAsJS(state),
    locale: getActiveLocaleSelector(state),
    version: 3,
    timestamp: Date.now(),
  });
};

export default savePackagesCacheThunk;
